import React, { createRef, useContext, useState } from 'react';

import loadImage from 'blueimp-load-image';

import { GlobalContext } from '../../../../../store';

import Modal from '../../../../../components/Modal';
import Tooltip from '../../../../../components/Tooltip';
import { useTabs } from '../../../../../contrib/Hooks/useTabs.hook';
import { SavePictureStep } from './Components/SavePictureStep';
import { SelectPictureStep } from './Components/SelectPictureStep';

interface IProps {
  modalToggle: any;
  modalIsOpen: boolean;
  clubId: number;
}

const ChangeImageModal = (props: IProps) => {
  const { modalIsOpen, modalToggle, clubId } = props;

  const {
    actions: {
      adminClubs: { editImage },
      avatar: { setClubBase64 },
      notifications: { push: pushNotification }
    }
  } = useContext(GlobalContext);

  const editorRef = createRef<any>();

  const [zoom, setZoom] = useState(1);

  const { activeTab, leaveTab, direction, setTab } = useTabs();

  const back = (): void => {
    setTab(null, 0);
  };

  const onClose = (): void => {
    setZoom(1);
    setTab(null, 0);
    modalToggle();
  };

  const handleZoom = (_: any, zoomToSet: number): void => {
    setZoom(zoomToSet);
  };

  const saveEdit = async (): Promise<any> => {
    onClose();

    const image = editorRef.current.getImage().toDataURL();

    const response = await editImage(clubId, image, 'profile_image');

    if (response.errors) {
      await pushNotification({
        status: 'unread',
        text: response.errors.profile.msg,
        type: 'error'
      });
      setTimeout(() => onClose(), 4000);
    } else {
      await pushNotification({
        status: 'unread',
        text: 'Club profile picture updated successfully',
        type: 'success'
      });
    }
  };

  const save = async (e: any): Promise<any> => {
    const file = e.target.files[0];
    const fx = async (img: any) => {
      setClubBase64(img.toDataURL());
      setTab(null, 1);
    };

    await (loadImage as any)(
      file,
      fx,
      { orientation: true, maxWidth: 600 } // Options
    );
  };

  const steps = [
    {
      content: <SelectPictureStep save={save} />,
      label: 'Select picture'
    },
    {
      content: (
        <SavePictureStep
          back={back}
          editorRef={editorRef}
          handleZoom={handleZoom}
          saveEdit={saveEdit}
          zoom={zoom}
        />
      ),
      label: 'Edit picture'
    }
  ];

  return (
    <Modal
      onClose={onClose}
      className="change-club-logo staff-scope"
      open={modalIsOpen}
      title="EDIT CLUB LOGO"
      tooltip={
        <Tooltip
          classes={{ fab: 'tooltip-fab--shift-top-2dot5' }}
          sectionKey="CHANGE_IMAGE_MODAL.TITLE"
        />
      }
    >
      <div className={`slider ${direction} admin-layout`}>
        {steps.map(({ content }, index) => (
          <div
            key={`club-settings-step-${index}`}
            className={`slide top admin-wrapper club-settings ${
              activeTab === index ? 'active' : ''
            } ${leaveTab === index ? 'leave' : ''}`}
          >
            {content}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export { ChangeImageModal };
